import { variables } from 'swag-client-common/styles/variables-js';
export const styles = {
  menuItem: {
    fontFamily: variables.fontFamilyRegular,
    textAlign: 'center',
    textTransform: 'uppercase',
    fontSize: '0.7rem',
    letterSpacing: '1.25px',
    color: '#999a9b'
  },
  selectedItem: {
    fontFamily: variables.fontFamilyRegular,
    textAlign: 'center',
    textTransform: 'uppercase',
    fontSize: '0.7rem',
    letterSpacing: '1.25px',
    backgroundColor: variables.colorPrimary,
    color: variables.colorWhite
  }
};